import { render, staticRenderFns } from "./CBreadcrumb.vue?vue&type=template&id=902f0894&"
import script from "./CBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./CBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports